"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var qs = _interopRequireWildcard(require("query-string"));
var _cookies = require("@kiwicom/cookies");
var _client = require("../platform/client");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// the reasoning for this can be found here https://skypicker.slack.com/archives/C7T7QG7M5/p1643727070647379
// tldr Commercial is using this affilIds for their promos
// Moved webgainsltdwebgains, syndic, and admitad to noRewriteAffiliateIds as requested @https://skypicker.slack.com/archives/CRMCMFP9P/p1733205765929219
const noRewriteAffiliateIds = ["5dm", "acquisition", "admitad", "adpump", "adwordsroutes", "adwordssearch", "affnetmarketingmediapvtltdkiwi1234", "cityads", "cj", "crm", "crmd", "crmtesting", "dgmax", "givt", "gtsalivesrocz", "lowcostavia", "maxbounty", "paidsocial", "retention", "stories", "syndic", "watchdog", "webgainsltdwebgains"];

// if we overwrite this B2C affiliates we will lose track of the ROI of the marketing campaigns
// we are running there, leading to wrong investment decisions
// more in the slack thread mentioned above, and this one: https://skypicker.slack.com/archives/CRMCMFP9P/p1669643672351149
// Added "cj_" to noRewriteAffiliateIdPrefixes requested @https://skypicker.slack.com/archives/CRMCMFP9P/p1733205765929219
const noRewriteAffiliateIdPrefixes = ["acquisition000", "action000", "akademiobusinesssearchw", "alabomshoplimitedepn", "ananasokelionsmonikasvil", "aventurescuwgt", "awareness000", "azaircomazair1", "buy000", "capturetheatlasllccapturetheatlas", "cj_", "consideration000", "cw", "digitalcrabllctravel", "doyoogo", "gtsalivesrocz", "hotelopialastminutetravel", "johnnytourwidget", "kerncountydepartmentofairportsnewbflwebsite", "letistebrnoaswidget", "letisteostravawidget", "lithuanianairportskunairportnew", "lw", "lyoness", "omgdomains", "paidsocial000", "quellecompagnietest", "servintdeeplink", "sofconnectadflightsearch", "thecoupondigicoup", "thetrailblazingtouristthetrailblazingtourist", "tipli", "travelintodayflights", "travelpayouts", "turismoplusbuscarvuelos", "virtualbusinessbvdkbillet", "virtualbusinessbvflyresor2021", "skypicker" // for info on why we need this prefix: https://skypicker.slack.com/archives/C7T7QG7M5/p1714050255289629
];
const getIsStartingWithPrefix = (id, prefixArr) => prefixArr.map(prefix => id.startsWith(prefix)).some(bool => bool);
const handleAffiliateId = function (fromAccount) {
  let {
    url
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    url: window.location.search
  };
  // We skip affiliate ID handling in webviews to prevent incorrectly overriding app-specific IDs
  // Slack thread: https://skypicker.slack.com/archives/C070706DC4X/p1731600484805449
  if ((0, _client.isWebview)()) {
    return;
  }
  const affiliateId = (0, _cookies.load)(_cookies.Cookie.AFFILIATE_ID);
  if (affiliateId != null && (noRewriteAffiliateIds.includes(affiliateId) || getIsStartingWithPrefix(affiliateId, noRewriteAffiliateIdPrefixes))) {
    return;
  }
  if (fromAccount) {
    (0, _cookies.save)(_cookies.Cookie.AFFILIATE_ID, fromAccount);
    return;
  }
  if (url == null) {
    return;
  }
  const {
    affilId,
    affilid
  } = qs.parse(url);
  if (!affilId && !affilid) {
    // removes affiliate info for logged-in user
    // if they didn't come directly from vendor,
    // which is decided by the URL parameter
    (0, _cookies.remove)(_cookies.Cookie.AFFILIATE_ID);
  }
};
var _default = exports.default = handleAffiliateId;